var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPaImgUpload = function SvgPaImgUpload(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 40,
    viewBox: "0 0 100 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    width: 100,
    height: 40,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F2F6F7",
    stroke: "#9BAAB6",
    strokeDasharray: 2,
    strokeLinejoin: "bevel",
    strokeWidth: 2,
    mask: "url(#prefix__b)",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#9BAAB6",
    fillRule: "nonzero",
    transform: "translate(39 11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.12 17.024H1.675C.75 17.024 0 16.274 0 15.348V1.675C0 .75.75 0 1.675 0H19.12c.925 0 1.675.75 1.675 1.675v13.673c0 .926-.75 1.676-1.675 1.676zM1.675 1.306c-.204 0-.369.165-.369.37v13.672c0 .098.04.192.108.261.07.07.163.108.261.108H19.12c.203-.001.366-.166.366-.369V1.675c0-.202-.163-.367-.366-.369H1.675z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.566 12.615h12.902c.211.006.407-.108.505-.295.098-.187.08-.413-.044-.583l-1.78-2.417c-.094-.13-.24-.212-.4-.226-.16-.014-.318.042-.433.155l-1.829 1.74-4.245-5.764c-.107-.146-.28-.23-.46-.225-.182.005-.349.1-.448.251L3.09 11.763c-.112.172-.119.391-.019.57.1.179.291.288.496.282z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.937,
    cy: 5.937,
    r: 1.937
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPaImgUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pa-img-upload.718214ffee9a4218def4cd0eff2f39a2.svg";